export default [
    {
        name: 'Line Measure Tool',
        displayName: 'Line Measure',
        icon: 'fas fa-horizontal-rule',
        mode: 'MeasureLineStringMode',
        description:
            'Click multiple times on the map to create a measure line. Double-click to finish the measure line.',
    },
    {
        name: 'Polygon Measure Tool',
        displayName: 'Polygon Measure',
        icon: 'fas fa-draw-polygon',
        mode: 'MeasurePolygonMode',
        description:
            'Click multiple times on the map to create a measure polygon. Double-click to finish the measure polygon.',
    },
    {
        name: 'Measure Eraser Tool',
        displayName: 'Measure Eraser',
        icon: 'fas fa-eraser',
        mode: 'simple_select',
        description: 'Click a measure record to erase it',
    },
];
